import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const UserObligations = () => {
  const sections = [
    {
      text: () => (
        <Box>
          <Typography>
            When using Topibro Technologies&apos; website or services, you agree
            to provide accurate, current, and complete information as required,
            maintain the security of any account credentials, and promptly
            notify us of any unauthorized use of your account. You are
            responsible for all activity conducted through your account.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Prohibited Conduct.</b> You must not use our website or services
            to: engage in any unlawful, fraudulent, or harmful activities;
            transmit any unsolicited or unauthorized advertising or promotional
            material; introduce malware, viruses, or any other harmful code;
            attempt to gain unauthorized access to any system, network, or data;
            copy, reproduce, or distribute any content from our platform without
            express written permission; impersonate any person or entity or
            misrepresent your affiliation with any person or entity.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Client-Provided Content.</b> Where you provide content, data,
            materials, or information to Topibro Tech in connection with a
            service engagement, you represent and warrant that you own or have
            the necessary rights to that content and that it does not infringe
            any third-party rights. You grant Topibro Tech a non-exclusive,
            royalty-free licence to use, process, and display such content
            solely for the purpose of delivering the agreed services.
          </Typography>
        </Box>
      ),
    },
    {
      text: () => (
        <Box>
          <Typography>
            <b>Confidentiality.</b> Both parties agree to keep confidential any
            proprietary or sensitive information disclosed in the course of a
            service engagement and not to disclose it to third parties without
            prior written consent, except as required by law.
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Container sx={{ my: 10 }} id="user-obligations">
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ justifyContent: 'left' }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
          >
            User Obligations
          </Typography>
          {sections.map((section, i) => (
            <Typography
              key={i}
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              {section.text()}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default UserObligations;
